import RouterSection from '@/Layout/components/RouterSection';
import { checkAuthorization } from '../NavigationGuards';
import * as OrderSessionManager from '@/utils/OrderSessionManager';

export default {
  path: '/order',
  name: 'order_home',
  component: RouterSection,
  mode: 'history',
  children: [
    {
      path: 'success',
      name: 'orderSuccess',
      component: () => import('@/views/order/Success'),
      beforeEnter: checkAuthorization,
    },
    {
      path: ':step?',
      name: 'gorderInfo',
      component: () => import('@/views/order'),
      beforeEnter: checkAuthorization,
      props(route) {
        const sessionId = route.query.sessionId;
        if (sessionId) {
          const session = OrderSessionManager.getSession(sessionId) || {};
          const { step = 'step1' } = route.params;
          const { goodsNoList, orderTempSeq, cartIds, isClosed, goodsCategory } = session;
          
          return {
            sessionId,
            step,
            goodsNo: isClosed ? [] : goodsNoList,
            orderTempSeq: orderTempSeq && String(orderTempSeq),
            cartIds,
            goodsCategory,
          };
        }

        return {};
      },
    },
  ],
};
